import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DiskSpaceComponent } from './disk-space.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    component: DiskSpaceComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
@NgModule({
  declarations: [
    DiskSpaceComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ]
})
export class DiskModule { }
